import React from 'react'

import './material-activation-layout.scss'

import cn from '../../../../commons/src/libs/class-names'
import {mapChildrenWithFragments} from '../../../../commons/src/services/react-children'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import MaterialActivationColumn from './material-activation-column'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    filterBar: React.ReactNode
    children: React.ReactNode
    empty: React.ReactNode
    isEmpty?: boolean
  }
>

const MaterialActivationLayout = ({
  className,
  filterBar,
  children,
  empty,
  isEmpty = false,
  ...props
}: Props) => (
  <div {...props} className={cn('MaterialActivationLayout', {}, className)}>
    <div className="MaterialActivationLayout__filterBar">{filterBar}</div>
    {!isEmpty && (
      <div className="MaterialActivationLayout__content">
        {mapChildrenWithFragments<React.ComponentProps<typeof MaterialActivationColumn>>(
          children,
          (child, i) =>
            React.cloneElement(child, {
              stripe: (i + 1) % 2 === 1,
            })
        )}
      </div>
    )}
    {isEmpty && <div className="MaterialActivationLayout__empty">{empty}</div>}
  </div>
)

export default MaterialActivationLayout
